import { datadogRum } from '@datadog/browser-rum'
import { datadogLogs } from '@datadog/browser-logs'

export const normalizeEnv = (env) => {
  const envLower = env?.toLowerCase()
  if (envLower === 'prod' || envLower === 'prod-ca') {
    return 'prod-ca'
  }
  if (envLower === 'preprod' || envLower === 'preprod-ca') {
    return 'preprod-ca'
  }
  return 'local'
}

export const sanitizeUrl = (url) => {
  try {
    const parsedUrl = new URL(url)
    const isUrlValid =
      !parsedUrl.pathname.includes('/static/') &&
      parsedUrl.pathname.includes('/babylonbytelushealth/')

    if (isUrlValid) {
      parsedUrl.search = '' // Remove query parameters
      parsedUrl.pathname = parsedUrl.pathname.replace(
        /[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}|[0-9]+/gi,
        '[REDACTED]'
      ) // Mask sensitive path segments (e.g., UUIDs or IDs)
    }
    return parsedUrl.toString()
  } catch (error) {
    return '[REDACTED]'
  }
}

export const beforeSend = (event, context) => {
  if (event.view) {
    event.view.url = sanitizeUrl(event.view.url)
    event.view.referrer = sanitizeUrl(event.view.referrer)
  }

  // Sanitize resource URLs
  if (event.resource) {
    event.resource.url = sanitizeUrl(event.resource.url)
  }

  // Sanitize long task scripts
  if (event.long_task?.scripts) {
    event.long_task.scripts = event.long_task.scripts.map((script) => ({
      ...script,
      source_url: sanitizeUrl(script.source_url),
      invoker: sanitizeUrl(script.invoker),
    }))
  }

  // Sanitize context
  if (context.location) {
    context.location.href = sanitizeUrl(context.location.href)
    context.location.search = ''
  }

  return true
}

/**
 * @deprecated use initDatadogLogs instead
 */
export const getLogConfig = (props) => ({
  ...props,
  site: 'datadoghq.com',
  forwardErrorsToLogs: true,
  sessionSampleRate: 100,
  forwardConsoleLogs: ['error'],
  beforeSend,
})

export const initDatadogRum = (props) => {
  datadogRum.init({
    ...props,
    site: 'datadoghq.com',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0, // disables session replay
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: false,
    traceSampleRate: 100,
    telemetrySampleRate: 100,
    defaultPrivacyLevel: 'mask',
    enablePrivacyForActionName: true,
    beforeSend,
  })
}

export const initDatadogLogs = (props) => {
  datadogLogs.init({
    ...props,
    site: 'datadoghq.com',
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
    forwardConsoleLogs: ['error'],
    beforeSend,
  })
}

export const setDatadogUser = (user) => datadogRum.setUser(user)
export const setDatadogLogUser = (user) => datadogLogs.setUser(user)
